/**
 * defa.routers.RoleApplicationRouter
 * The router for the RoleApplicationController
 * @version 1.0.0
 */
const RoleApplicationRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		'roleapplications(/)' : 'showAllRoleApplications',
		'roleapplications/:id(/)' : 'showRoleApplication',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default RoleApplicationRouter;